import { TSelectFilterOption } from '@/shared/components/ui/option-select/option-select.types';
import { UNKNOWN_ENUM_VALUE } from '@/shared/utils/enum/enum.constants';
import { TGetEnumOptionsConfig } from '@/shared/utils/enum/get-enum-options.types';

// The value is cast to string because the UNKNOWN member may not exist in the
// generated enum type yet (it's added on regeneration), but can arrive at runtime.
const isSelectable = <T extends string>(
  value: T,
  exclude: readonly T[],
): boolean =>
  (value as string) !== UNKNOWN_ENUM_VALUE && !exclude.includes(value);

// UNKNOWN is a read-only fallback (see enum.constants) and is always excluded, so
// it can never be offered in a filter or form dropdown.
export const getEnumValues = <T extends string>(
  enumObject: Record<string, T>,
  exclude: readonly T[] = [],
): T[] =>
  Object.values(enumObject).filter((value) => isSelectable(value, exclude));

export const getEnumOptions = <T extends string>(
  enumObject: Record<string, T>,
  { getLabel, exclude = [] }: TGetEnumOptionsConfig<T>,
): TSelectFilterOption[] =>
  getEnumValues(enumObject, exclude).map((value) => ({
    value,
    label: getLabel(value),
  }));
